<template>
	<section id="radical-broadcast" :class="[open ? 'sched-open' : '', muted ? 'muted' : '', fields.video_sizing == true ? 'cover':'contain' ]">
		<div class="rb-video-wrap" @click="toggleMuted" :class="[fields.video_sizing, cursorBroadcastStyle && muted ? 'broadcast-cursor-sound-on' : null, cursorBroadcastStyle && !muted ? 'broadcast-cursor-sound-off' : null]">
    	<video id="rb-video" oncontextmenu="return false;" controlsList="nodownload" playsinline="" autoplay="" loop="" :muted="muted" preload="auto" :src="broadcastLink" :class="fields.video_sizing">
    	</video>
    	<div class="safari-fix"></div>
  	</div>
	  
	  <div ref="schedule" id="schedule" :class="open ? 'is-open' : ''">
		  <article>
			  
			  <div class="wrap schedule-header">
          <header>
            <h2><span v-text="currentDate"/></h2>
            <hr>
          </header>
	      </div>
			  
			  <div class="wrap schedule-wrap">
				  
				  <main>
						
				      <h2 class="text-extended"><strong>{{ fields.title }}</strong></h2>
<!-- 				      <h3>{{ fields.start_date }} <span class="text-mono">&rarr;</span> {{ fields.end_date }}</h3> -->
				      <prismic-rich-text :field="fields.description" class="collection-description"/>
				      
				      <ul>
					      <RBProgram v-for="(program, index) in orderedPrograms2" :key="program.id" :program="program" :index="index" ></RBProgram>
				      </ul>
				      				      
					</main>
				
			  </div>
			  
		  </article>
	  </div>
	    
	    
<!-- 	    <div class="ticker bg-trans loaded" data-title="Radical Broadcast">

	    	<div>
	    		<marquee-text :duration="60">
	    		  <h3 class="ticker-item fs-normal">Radical <span class="text-extended">Broadcast</span></h3>
		          <span class="ticker-item h3 fs-normal">
		  			<span class="clock text-mono">
		  				<span class="h" v-text="currentTimeHours" />
		  				<span class="m" v-text="currentTimeMinutes" />
		  			    <span class="s" v-text="currentTimeSeconds" />
		  	        </span>
		          </span>
	    		  <span class="ticker-item performa fs-normal">Performa</span>
	    		  <span class="text-condensed ticker-item performa fs-normal">Radical <span class="text-extended">Broadcast</span></span>
	    		  <span class="ticker-item performa fs-normal">Performa</span>
	    		</marquee-text>
	    	</div>
	    </div> -->
	</section>
</template>

<style lang="scss">

.rb-video-wrap {
	background-color: #000;
}

#radical-broadcast #rb-video.portrait {
	object-fit: contain;
	min-height: 0px;
	height: 100%;
}

#radical-broadcast.contain #rb-video{
	object-fit: contain !important;
}

// .broadcast-cursor-sound-on {
// 	cursor: url('../assets/img/mute.svg'), default !important;
// }

// .broadcast-cursor-sound-off {
// 	cursor: url('../assets/img/unmute.svg'), default !important;
// }

</style>

<script>
import RBProgram from './RBProgram.vue'
import moment from 'moment'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
	
export default {
  name: 'RadicalBroadcast',
  props: {
	  cursorBroadcastStyle: Boolean,
	  soundOff: Boolean
  },

  data () {
    return {
      fields: {
        title: null,
        start_date: null,
        end_date: null,
        description: null,
        video_sizing: null
      },
      currentTime: null,
	    currentTimeHours: null,
	    currentTimeMinutes: null,
	    currentTimeSeconds: null,
	    currentDate: null,
    	programs:[],
		muted: true,
		schedule: null
    }
  },
  components: {
		RBProgram,
  },
  computed: {
	  orderedPrograms () {
		  return _.orderBy(this.programs, 'primary.program_start')
	  },
	  orderedPrograms2 () {
			var programs = _.orderBy(this.programs, 'primary.program_start');
		  var time = moment();
		  var nowToMidnight = [];
		  var zeroToNow = [];
		  var ordered = [];
		  
		  for (var i = 0; i < programs.length; i++) {
			  var time = moment();
			  var start = moment(programs[i].primary.program_start.replace(/[^0-9]/ig, ""), "hmm");
			  var end = moment(programs[i].primary.program_end.replace(/[^0-9]/ig, ""), "hmm");
			  
			  if (time.isBetween(start, end)) {
				  ordered.push(programs[i]);
			  }
			  
			  else if (time.isBefore(start)) {
				  nowToMidnight.push(programs[i]);
			  }
			  
			  else if (time.isAfter(end)) {
				  zeroToNow.push(programs[i]);
			  }
			  
		  }
		  
		  ordered.push(...nowToMidnight);
		  ordered.push(...zeroToNow);
		  return ordered;
	  },
	  open () {
		  return this.$store.state.schedOpen
	  },
	  ...mapGetters([
      'broadcastLink',
      'activeVideo'
		]),
		activeVideo () {
			return this.$store.state.activeVideo;
		},
		soundOn () {
			return this.$store.state.soundOn;
		}
  },
  watch: {
	  open: function (open) {
		  console.log('sched watcher')
	  },

	  soundOff (newVal) {
		  if (newVal === false) this.muted = false;
		  if (newVal === true) this.muted = true;
	  },

	  soundOn (newVal) {
		  if (newVal) this.muted = false;
		  if (!newVal) this.muted = true;
	  }
  },
	methods: {
		closeSched () {
    	this.$store.dispatch('toggleSched')
    	},
		toggleMuted () {
		  this.muted = !this.muted;
		  this.$store.commit('toggleSound');
		  this.$ga.event('RadicalBroadcast', 'toggleMute')
	  },
    updateCurrentTime() {
      this.currentTime = moment().local();
    },
		updateCurrentTimeHours() {
      this.currentTimeHours = moment().format('h');
    },
    updateCurrentTimeMinutes() {
      this.currentTimeMinutes = moment().format('mm');
    },
    updateCurrentTimeSeconds() {
      this.currentTimeSeconds = moment().format('ssa');
    },
    updateCurrentDate() {
      this.currentDate = moment().format('dddd, MMMM DD, YYYY');
    },
 		getContent () {
		  this.$prismic.client.getSingle('radical_broadcast')
		  	.then((document) => {
			  	this.fields.title = document.data.broadcast_title;
			  	this.fields.video_sizing = document.data.video_sizing;
			  	this.fields.start_date = document.data.start_date;
			  	this.fields.end_date = document.data.end_date;
			  	this.fields.description = document.data.broadcast_description;
			  	this.programs = document.data.body;
		  	})
	  }
	},
	created () {
		
	  this.getContent();
	  this.currentTime = moment().local();
	  this.currentTimeHours = moment().format('h');
	  this.currentTimeMinutes = moment().format('mm');
	  this.currentTimeSeconds = moment().format('ssa');
	  this.currentDate = moment().format('dddd, MMMM DD, YYYY');

    setInterval(() => this.updateCurrentTimeHours(), 1 * 1000);
    setInterval(() => this.updateCurrentTimeMinutes(), 1 * 1000);
    setInterval(() => this.updateCurrentTimeSeconds(), 1 * 1000);
  },
  mounted () {
	  
	  let timeout = null;
	  this.$el.addEventListener('mousemove', () => {
		clearTimeout(timeout);
		this.$refs.schedule.style.opacity = 1;
		timeout = setTimeout(() => {
			if (this.$store.state.schedOpen) {
				this.$refs.schedule.style.opacity = 0;
				this.$store.dispatch('toggleSched');
			}
			
		}, 30000);
	  })
  }
}
</script>